import { observer } from 'mobx-react';
import * as React from 'react';
import { UpcomingProgramModule } from '../../../ProgramStore/Types';
import { T } from '../../../Translations';
import CompleteSegmentIcon from '../../Cutesies/CompleteSegmentIcon';
import OutlineLockIcon from '../OutlineLockIcon';
import * as style from '../style.module.css';

interface Props {
  modules: UpcomingProgramModule[];
}

const isComplete = (programModule: UpcomingProgramModule): boolean =>
  programModule.segments.length > 0 &&
  programModule.segments.every((segment) => segment.status === 'Complete');

/**
 * The outline of a program that has not started yet. Nothing can be opened, so each
 * module shows only its title: finished (registration, for example) or locked.
 */
const UpcomingOutlineModules: React.FC<Props> = ({ modules }) => (
  <ol>
    {modules.map((programModule) => {
      const complete = isComplete(programModule);
      return (
        <li
          key={`module-${programModule.id}`}
          className={style.module}
          data-test-outline-module={programModule.id}
        >
          <div className={complete ? style.complete : style.inaccessible}>
            <div
              className={style.moduleIcon}
              data-test-module-icon={complete ? 'complete' : 'locked'}
            >
              {complete ? <CompleteSegmentIcon /> : <OutlineLockIcon />}
              <div className={style.moduleLine} />
            </div>
            <div className={style.moduleLabel} data-test-module-title={programModule.title}>
              {programModule.title}
              <span className={style.srOnly}>
                {complete ? <T kind="Completed" /> : <T kind="Locked" />}
              </span>
            </div>
          </div>
        </li>
      );
    })}
  </ol>
);

export default observer(UpcomingOutlineModules);
